import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { ActivatedRoute, Data, NavigationEnd, Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs';
import { AppBreadcrumbComponent } from "../../../layouts/full/shared/breadcrumb/breadcrumb.component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/login.service';
import { IpdFeatureService } from 'src/app/services/ipd-feature.service';

interface TopCard {
  id: number;
  color: string;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}
@Component({
  selector: 'app-setting-tab',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    RouterModule,
    AppBreadcrumbComponent,
    TranslateModule
  ],
  templateUrl: './setting-tab.component.html',
  styleUrl: './setting-tab.component.scss'
})
export class SettingTabComponent implements OnInit {
  pageInfo: Data | any = Object.create(null);
  topcards: TopCard[] = [];
  selectedTab: TopCard;
  constructor(
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translate: TranslateService,
    private _loginService: LoginService,
    private _ipdFeature: IpdFeatureService
  ) {
    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      // tslint:disable-next-line - Disables all
      .subscribe((event) => {
        // tslint:disable-next-line - Disables all
        this.titleService.setTitle(event['title']);
        this.pageInfo = event;
      });
  }

  ngOnInit(): void {
    const userRole = this._loginService.getUsrRoleFromToken();

    this.topcards = [
      {
        id: 1,
        color: 'accent',
        img: '/assets/images/svgs/hospital2.svg',
        title: this.translate.instant('ENTITY.HOSPITAL'),
        subtitle: '3,685',
        link: '/hospitalsetting'
      },
    ];
    if (userRole && userRole.includes('Admin')) {
      this.topcards.push({
        id: 2,
        color: 'accent',
        img: '/assets/images/svgs/users.svg',
        title: this.translate.instant('ENTITY.USER'),
        subtitle: '932',
        link: '/user'
      });
    }
    this.topcards.push(
      {
        id: 3,
        color: 'accent',
        img: '/assets/images/svgs/categorys.svg',
        title: this.translate.instant('ENTITY.CATEGORY'),
        subtitle: '256',
        link: '/clinical/clinicalcategory'
      },
      {
        id: 4,
        color: 'accent',
        img: '/assets/images/svgs/appointment.svg',
        title: this.translate.instant('ENTITY.APPOINTMENT_TYPE'),
        subtitle: '932',
        link: '/appointmenttab'
      },
      {
        id: 5,
        color: 'accent',
        img: '/assets/images/svgs/medicliam.svg',
        title: this.translate.instant('ENTITY.MEDICLAIM'),
        subtitle: '932',
        link: '/Mediclaim'
      },
      {
        id: 6,
        color: 'accent',
        img: '/assets/images/svgs/medicine.svg',
        title: this.translate.instant('ENTITY.DRUG'),
        subtitle: '932',
        link: '/Drug'
      },
    );
    if (this._ipdFeature.isEnabled) {
      this.topcards.push({
        id: 7,
        color: 'accent',
        img: '/assets/images/svgs/IPD.svg',
        title: this.translate.instant('ENTITY.IPD'),
        subtitle: '932',
        link: '/ipd'
      });
    }
    this.selectedTab = this.topcards[0];
  }

  selectTab(tab: any) {

    if (tab.link) {
      this._router.navigate([tab.link]);
    }
  }
}
